module.exports = __webpack_public_path__ + "static/tennis-4a0d8aae53090b18f5fb912495e2a5c0.webm";